<template>
    <nav class="sidemenu">
        <ul class="sidemenu__list">
            <li v-if="checkPermissions(item)" v-for="(item, index) in icons" :key="index" class="sidemenu__item" :class="{ 'active': activeStep === index }">
                <button class="sidemenu__button" :disabled="item.disabled" @click="changeStep(index)">
                    <icon class="sidemenu__icon small-svg" :name="item.icon" />
                    <div v-if="item.highlight" class="sidemenu__highlight">&nbsp;</div>
                    <div v-if="item.counter" class="sidemenu__counter">{{ item.counter }}</div>
                    <div class="sidemenu__label" :class="{'custom-text': item.text.length > 13}">{{ item.text }}</div>
                </button>
            </li>
        </ul>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            activeStep: this.initStep
        }
    },
    props: [
        'initStep',
        'icons'
    ],
    computed: {
        ...mapGetters({
            permissions: 'permissions'
        })
    },
    methods: {
        changeStep (selectedStep) {
            this.activeStep = selectedStep
            this.$emit('changeStep', selectedStep)
        },
        checkPermissions (item) {
            // Further permissions check for specific user e.g. front desk employee
            let active = item.active
            for (let i in this.permissions) {
                if (item.icon === i && !this.permissions[i].enabled) {
                    active = false
                } else if (item.icon === 'task' && !this.permissions.tasks.enabled) {
                    active = false
                }
            }
            return active
        }
    }
}
</script>

<style lang="scss">
@import '../../../scss/utils/colors.scss';
@import '../../../scss/utils/media-queries';

.sidemenu {
    left: 0;
    position: absolute;
    top: 48px;
    width: 108px;
    z-index: 10;

    @include sm-only {
        display: none;
    }

    &__list {
        list-style: none;
        margin: 0;
        padding: 0;
    }
    &__item {
        background: $light-gray;

        &.active {
            background: $dark-blue;
            color: white;
            text-align: center;

            div {
                color: white;
            }
            svg {
                fill: white;
            }
        }
        &:first-child {
            border-top-right-radius: 3px;
        }
        &:last-child {
            border-bottom-right-radius: 3px;
        }

        svg {
            fill: $dark-gray;
        }
    }
    &__item + &__item {
        margin-top: 1px;
    }
    &__button {
        padding: 14px 6px;
        position: relative;
        width: 100%;

        svg {
            width: 28px;
        }
        .highlight {
            background-color: $green;
        }
    }
    &__highlight {
        background: #2ecc71;
        border-radius: 50%;
        height: 18px;
        position: absolute;
        right: 10px;
        top: 10px;
        width: 18px;
    }
    &__counter {
        background: #4d697c;
        border-radius: 12px;
        color: #fff;
        font-size: 0.75rem;
        font-weight: 500;
        left: calc(50% + 24px);
        line-height: 1.2em;
        padding: 0.2em 0.6em;
        position: absolute;
        top: 10px;
    }
    &__label {
        font-size: 0.8rem;
        color: $black;
        line-height: 1.25em;

        &.custom-text {
            line-height: 1em;
            margin-left: auto;
            margin-right: auto;
            width: 68px;
            word-wrap: break-word;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/nav/guide-nav.vue